import api from "./api";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import { resources } from "./resources";

class Parametrizacao {
    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.parametro}/GetWithFilter/${ToQueryString({ ...filters })}`);
    }

    async getContextos() {
        return await api.get<any>(`${resources.parametro.toLowerCase()}/getAllContextos`);
    }

    async getNomes() {
        return await api.get<any>(`${resources.parametro.toLowerCase()}/getAllNomes`);
    }

    async create(data: any) {
        return await api.post<any>(`${resources.parametro.toLowerCase()}`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.parametro}/Update`, data);
    }

    async disable(id: any) {
        return await api.put<any>(`${resources.parametro.toLowerCase()}/disable/${id}`);
    }
}

export default new Parametrizacao();
